

async function selectType ( type ){

    const
        Selector_Delivery_With = `#delivery-option-chosen` ,
        Selector_Date_Picker = `#requested-delivery-date` ,
        Selector_Preferences = `.Delivery_Choice-Types`

    const container = document
        .querySelector(Selector_Preferences)

    const picker = document
        .querySelector(Selector_Date_Picker)

    const infoType = document
        .querySelector(Selector_Delivery_With)


    function resetPicker (){
        picker.classList.remove('non-empty')
        picker.value = ''
    }

    resetPicker()

    picker.removeAttribute('error')
    picker.removeAttribute('weekdays')


    picker.onchange = () => {

        const { value } = picker

        if( value === '' ){
            resetPicker()
            picker.removeAttribute('weekdays')
            return
        }

        const date = new Date(value)
        const day = date.getUTCDay()

        if( [ 0 , 6 ].includes(day) ){
            resetPicker()
            picker.setAttribute('weekdays','')
            return
        }


        picker.classList.add('non-empty')
    }


    // Reset validation

    container.removeAttribute('error')


    // Enable / disable date picker

    const hidden = ( type.value === 'Sofort' )

    picker.dataset.hidden = String(hidden)

    infoType.innerText = type.value
}

window.selectType = selectType


function readDeliveryData (){

    const undo = window.CartUndo ??= {}
    undo.type ??= ''
    undo.date ??= ''


    const selector =
        `#Delivery_Choice-Preview >` +
        `[ type = 'application/json' ]`

    const element = document
        .querySelector(selector)

    if( ! element )
        return


    const { innerText } = element

    const data = JSON.parse(innerText)
    undo.type = data.type ?? ''
    undo.date = data.date ?? ''
}

window.readDeliveryData = readDeliveryData





document.addEventListener('DOMContentLoaded',() => {

    readDeliveryData()

    sections.instances
    .find(( instance ) => instance.type === 'cart')
    ?._updateDeliveryPicker()
})
